import "./RamanHandheldAnalyzers.module.css";
import Header from "@/reusable_sections/Header";
import RamanHero from "./sections/RamanHero";
import Rigaku from "./sections/Rigaku";
import AccessoriesIntegration from "./sections/AccessoriesIntegration";
import ConsultationCTA from "./sections/ConsultationCTA";
import Footer from "@/reusable_sections/Footer";
export default function RamanHandheldAnalyzersPage() {
  return <div>
      <Header />
      <RamanHero />
      <Rigaku />
      <AccessoriesIntegration />
      <ConsultationCTA />
      <Footer />
    </div>;
}